import { CardStoreExtension, ICardStoreExtensionContext } from 'tessa/cards/extensions';
import { CdCardTypes } from 'src/cdScripts/Helpers/CdCardTypes';
import { Guid } from 'tessa/platform';
import { ValidationResultType } from 'tessa/platform/validation';
import { PkCardTypes } from 'src/pkScripts/Helpers/PkCardTypes';

// Запрет сохранения для выведенных из экспуатации типов карточек.
export class DecommissionedTypesStoreExtension extends CardStoreExtension {

    public beforeRequest(context: ICardStoreExtensionContext) {
        var card = context.request.card;

        if (
            Guid.equals(card.typeId, CdCardTypes.PkZosRvDocumentypeID)    // TES-12237 Отключить "Документ ЗОС/РВ"
            || Guid.equals(card.typeId, CdCardTypes.PkGlazingOrderTypeID) // TES-12238 Отключить "Заявки на остекление"
            || Guid.equals(card.typeId, CdCardTypes.IrdDocumentTypeID)    // TES-12295 Отключить "ИРД"
            || Guid.equals(card.typeId, CdCardTypes.ArDocumentIdpTypeID)  // TES-12239 Отключение "ИДП"
            || Guid.equals(card.typeId, PkCardTypes.PkWorkOrderTypeID)  // TES-12242 Отключение НЗ
            || Guid.equals(card.typeId, CdCardTypes.PkAdditionalWorksContractOrderTypeID) 	    // TES-12241 Отключение АРФО
            || Guid.equals(card.typeId, PkCardTypes.PkProtocolTypeID) 				       	    // TES-12243 Отключение Протоколов
            || Guid.equals(card.typeId, CdCardTypes.PkRequestForMaterialsTypeID) 				// TES-12240 Отключение Заявок на материалы
            || Guid.equals(card.typeId, CdCardTypes.PkExecutiveDocumentationTypeID) 			// TES-12553 Отключение ИД
            || Guid.equals(card.typeId, CdCardTypes.PkExecutiveSchemeTypeID) 					// TES-12554 Отключение ИС
            || Guid.equals(card.typeId, CdCardTypes.TechnicalDocumentationTypeID) 			    // TES-12555 Отключение ТД

        ) {
            context.validationResult.add(ValidationResultType.Error, "Сохранение карточки данного типа невозможно, так как этот функционал выведен из эксплуатации.");
        }
    }

}